/**
 * Classe de fonctions utilitaires pour la gestion du DOM.
 */
export class WizDOMUtils {
  /**
   * Retourne la position de l'élément pElement dans le container parent (pas forcémment direct) d'id pParentId.
   *
   * @param pElement élément dont on souhaite déterminer la position
   * @param pParent ID du container parent OU instance de l'élément parent
   * @returns position de l'élément
   */
  public static determineItemPosition(
    pElement: HTMLElement,
    pParent: string | HTMLElement
  ): number {
    if (!pElement) {
      return -1;
    }
    if (typeof pParent === 'string') {
      if (pElement.parentElement?.id === (pParent as string)) {
        return WizDOMUtils.indexOfHtmlElement(pElement);
      }
    } else if (pParent && pElement.parentElement === pParent) {
      return WizDOMUtils.indexOfHtmlElement(pElement);
    }
    return WizDOMUtils.determineItemPosition(pElement.parentElement, pParent);
  }

  /**
   * Retourne la position de l'élément pElement par rapport à son parent.
   *
   * @param pElement élément du DOM
   * @returns Position de l'élément
   */
  public static indexOfHtmlElement(pElement: HTMLElement): number {
    return Array.from(pElement.parentElement.children).indexOf(pElement);
  }

  /**
   * Ajout d'un élément pChild à un élément parent pParent à la position pTargetIndex.
   * Si l'élément existe déjà, il est repositionné si nécessaire.
   *
   * @param pChild élément à insérer
   * @param pParent Parent de l'élément
   * @param pTargetIndex Position de l'élément
   */
  public static insertChildElement(
    pChild: HTMLElement,
    pParent: HTMLElement,
    pTargetIndex: number
  ): void {
    if (!pParent || !pChild) {
      return;
    }
    let parentChildren: Element[] = Array.from(pParent.children);
    if (pTargetIndex < 0 || pTargetIndex >= parentChildren.length) {
      return;
    }
    const existingChildIndex: number = parentChildren.indexOf(pChild);
    if (existingChildIndex > -1) {
      if (existingChildIndex !== pTargetIndex) {
        pParent.removeChild(pChild);
        parentChildren = Array.from(pParent.children);
      } else {
        return;
      }
    }
    if (pTargetIndex >= parentChildren.length) {
      pParent.appendChild(pChild);
    } else {
      pParent.insertBefore(pChild, parentChildren[pTargetIndex]);
    }
  }
}
